import { render, staticRenderFns } from "./AdvertList.vue?vue&type=template&id=19a0fa53&scoped=true&lang=pug&"
import script from "./AdvertList.vue?vue&type=script&lang=js&"
export * from "./AdvertList.vue?vue&type=script&lang=js&"
import style0 from "./AdvertList.vue?vue&type=style&index=0&id=19a0fa53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a0fa53",
  null
  
)

export default component.exports